document.addEventListener('DOMContentLoaded', () => {
  // Bezpiecznik: Uruchamiamy tylko na stronie głównej
  if (window.location.pathname !== '/') {
    document.body.classList.add('logo-animation-finished');
    return;
  }

  // Szukamy oryginalnego logo w nagłówku, aby pobrać jego dokładne wymiary i pozycję
  const realLogo = document.querySelector('.header__heading img, .header__heading svg, .header__heading-logo img');
  if (!realLogo) {
    document.body.classList.add('logo-animation-finished');
    return;
  }

  // Pobieramy link do grafiki bezpośrednio z oryginału
  const LOGO_URL = realLogo.src || "https://hausmaleficarum.com/cdn/shop/files/logo_kosc_sloniowa_shopify.png?v=1772401697&width=300";
  const isDesktop = window.innerWidth > 990;

  const maxScroll = isDesktop ? 400 : window.innerHeight * 0.4;
  const startWidth = isDesktop ? 320 : window.innerWidth * 0.6; // 60% szerokości ekranu na mobile

  // 1. Overlay (czarne tło)
  const overlay = document.createElement('div');
  overlay.className = 'hm-animation-overlay';
  document.body.appendChild(overlay);

  // 2. Animowane logo
  const logo = document.createElement('img');
  logo.src = LOGO_URL;
  logo.className = 'hm-animated-logo';
  document.body.appendChild(logo);

  // 3. Napisy Hero
  const heroContent = document.querySelectorAll('.banner__content, .hero__text-content');
  heroContent.forEach(el => {
    el.style.opacity = '0';
    el.style.transform = 'translateY(20px)';
    el.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
  });

  document.body.classList.add('logo-animation-ready');

  function renderAnimation() {
    const scrollY = window.scrollY;
    const rawProgress = Math.min(scrollY / maxScroll, 1);
    const progress = 1 - Math.pow(1 - rawProgress, 3); // Łagodne hamowanie

    // Odsłanianie napisów Hero
    if (scrollY > 30) {
      heroContent.forEach(el => { el.style.opacity = '1'; el.style.transform = 'translateY(0)'; });
    } else {
      heroContent.forEach(el => { el.style.opacity = '0'; el.style.transform = 'translateY(20px)'; });
    }

    // ========================================================
    // DYNAMICZNE WYLICZANIE POZYCJI DOCELOWEJ
    // ========================================================
    const targetRect = realLogo.getBoundingClientRect();
    
    // Punkt startowy (środek ekranu)
    const startX = window.innerWidth / 2;
    const startY = window.innerHeight / 2;

    // Punkt docelowy (środek oryginalnego logo w nagłówku)
    const endX = targetRect.left + (targetRect.width / 2);
    const endY = targetRect.top + (targetRect.height / 2);
    const endWidth = targetRect.width || (isDesktop ? 120 : 100);

    // Aktualna pozycja i rozmiar w danej klatce
    const currentX = startX + (endX - startX) * progress;
    const currentY = startY + (endY - startY) * progress;
    const currentWidth = startWidth + (endWidth - startWidth) * progress;

    logo.style.left = `${currentX}px`;
    logo.style.top = `${currentY}px`;
    logo.style.transform = `translate(-50%, -50%)`;
    logo.style.width = `${currentWidth}px`;
    
    overlay.style.opacity = (1 - progress).toString();
    
    // PERFEKCYJNE PRZEKAZANIE (Błyskawiczna zmiana przy 99% progressu)
    if (rawProgress >= 0.99) {
       document.body.classList.add('logo-animation-finished');
       logo.style.opacity = "0"; 
    } else {
       document.body.classList.remove('logo-animation-finished');
       logo.style.opacity = "1";
    }
  }

  // Uruchamiamy renderowanie
  window.addEventListener('scroll', renderAnimation, { passive: true });
  requestAnimationFrame(() => { renderAnimation(); });
});